<template>
<div id="midialog">
  <v-toolbar flat color="white">
    <v-toolbar-title>Sentidos</v-toolbar-title>
    <v-divider
      class="mx-4"
      inset
      vertical
    ></v-divider>
    <div class="flex-grow-1"></div>
    <v-dialog v-model="dialog" persistent>
      <v-form ref="form" v-model="valid">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Actualizar</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline"> Actualizar Sentidos</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    v-model="sentido.nombre"
                    label="Nombre"
                    @input="v => { sentido.nombre = v.toUpperCase() }"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col>
                    <BaseSelect
                      label="Materia"
                      :items = "getAllMaterias"
                      v-model="via.materia_id"
                    />
                  </v-col> -->
                </v-row>
                <v-col cols="12">
                  <v-checkbox v-model="activo" label="Activo" :value="activo"></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-toolbar>

</div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import BaseSelect from "../../components/BaseSelect.vue";

export default {
  components: {
    BaseSelect
  },
  data() {
    return {
      valid: true,
      dialog: false,
      activo: true,
      sentido: {}
    };
  },
  computed: {
    ...mapGetters(["getSentidoSelected"])
  },
  created() {
    this.sentido = this.$store.state.catSentidos.sentido_selected;
    if (this.sentido.deleted_at) {
      this.activo = false
    }else {
      this.activo = true
    }
    // this.$store.dispatch("GET_ALL_MATERIAS", { url: "materias" });
    // if (!this.sentido.id) {
    //   this.$router.push({ name: "Sentidos" });
    // }
  },
  mounted() {
    this.dialog = true;
  },
  methods: {
    close() {
      this.dialog = false;
      return this.$router.push({ name: "Sentidos" });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.sentido.activo = this.activo
        this.$store.dispatch("EDIT_SENTIDO",  { url: "/sentido/" +  this.sentido.id, data: this.sentido } ).then(res => {
          this.$swal({
            title: "Exito!!!",
            text: res.data.message,
            icon: "success",
            confirmButtonText: "Aceptar"
          });
          this.$router.push({ name: "Sentidos" });
        })
        .catch(error => {
          this.$swal({
            title: "Error!!!",
            text: error.response.data.message,
            icon: 'warning',
            confirmButtonText: "Aceptar"
          })
        });
      }
    }
  }
};
</script>
